module.exports = __webpack_public_path__ + "static/media/main idea.39c2500e.mp3";